import cloneDeep from 'lodash/cloneDeep'
import {
    ADD_TO_EQUIPMENT, REMOVE_FROM_EQUIPMENT,
} from '../../actions/game/equipment.actions'

const initialState = {}

const rosterReducer = (state = initialState, action) => {
    const { payload } = action

    switch (action.type) {
        case ADD_TO_EQUIPMENT: {
            const { items, unitID } = payload
            const newEquipment = items.map((item) => {
                const { itemID, slot } = item
                return {
                    [itemID]: {
                        unitID,
                        itemID,
                        slot,
                    },
                }
            })
            return Object.assign(cloneDeep(state), ...newEquipment)
        }

        case REMOVE_FROM_EQUIPMENT: {
            const { items } = payload
            const newState = cloneDeep(state)

            items.map(entry => delete newState[entry])

            return newState
        }

        default: {
            return state
        }
    }
}

export default rosterReducer
